import React from "react"
import styled from "styled-components"

import { FlexItem } from "components/box"
import { Paragraph } from "components/text"
import Icon from "components/icon"

export type MedicationСardHeaderProps = {
  name: string
  isNewProduct?: boolean
}

const HeaderTitle = styled(Paragraph)`
  font-size: 1.125rem;
`

export const MedicationСardHeader: React.FC<MedicationСardHeaderProps> = ({ name, isNewProduct = false }) => (
  <FlexItem
    color="evergreen"
    mb={[0, null, "0.0625rem"]}
    justifyContent={`${isNewProduct ? "space-between" : "end"} `}
    flex={1}
  >
    <HeaderTitle bold>{name}</HeaderTitle>
    {isNewProduct && <Icon alignSelf="flex-start" name="newBadge" />}
  </FlexItem>
)
